import React, { useEffect } from 'react';
import './modal-portfolio.css';
import { FiX, FiGithub, FiExternalLink, FiCalendar, FiCode } from 'react-icons/fi';

const ModalPortfolio = ({ project, isOpen, onClose }) => {
  useEffect(() => {
    // Bloquear scroll quando modal aberto
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    // Fechar com ESC
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen || !project) return null;

  return (
    <div className="modal-overlay" onClick={onClose} aria-modal="true" role="dialog">
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <h2 className="modal-title">{project.name}</h2>
          <button
            type="button"
            className="modal-close-btn"
            onClick={onClose}
            aria-label="Fechar modal"
          >
            <FiX size={24} />
          </button>
        </div>

        {/* Conteúdo */}
        <div className="modal-body">
          {/* Imagem */}
          <div className="modal-image-wrapper">
            <img
              src={project.image}
              alt={project.name}
              className="modal-image"
            />
          </div>

          {/* Informações */}
          <div className="modal-info">
            <div className="modal-info-item">
              <FiCalendar className="modal-info-icon" />
              <div>
                <h4>Ano</h4>
                <p>{project.year}</p>
              </div>
            </div>

            <div className="modal-info-item">
              <FiCode className="modal-info-icon" />
              <div>
                <h4>Função</h4>
                <p>{project.role}</p>
              </div>
            </div>
          </div>

          {/* Descrição */}
          <div className="modal-section">
            <h3 className="modal-section-title">Sobre o Projeto</h3>
            <p className="modal-description">{project.description}</p>
          </div>

          {/* Tecnologias */}
          <div className="modal-section">
            <h3 className="modal-section-title">Tecnologias Utilizadas</h3>
            <div className="modal-tech-list">
              {project.technologies.map((tech, idx) => (
                <span key={idx} className="modal-tech-item">
                  {tech}
                </span>
              ))}
            </div>
          </div>

          {/* Botões de Ação */}
          <div className="modal-actions">
            {project.website && (
              <a
                href={project.website}
                target="_blank"
                rel="noopener noreferrer"
                className="modal-btn modal-btn-primary btn-project-primary"
              >
                <FiExternalLink />
                Abrir Site
              </a>
            )}

            {project.github && (
              <a
                href={project.github}
                target="_blank"
                rel="noopener noreferrer"
                className="modal-btn modal-btn-secondary"
              >
                <FiGithub />
                Ver no GitHub
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalPortfolio;